import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { DAY_OF_WEEK_ORDERING, DAY_OF_WEEK_TO_INFO_MAPPING } from '@tcl-argon-utils/utils';
import { Classes } from 'jss';
import { GrayscalePalette } from '@tcl-boron-colors/colors';

const useStyles: (data?: { theme?: Jss.Theme }) => Classes<'root' | 'weekday'> = createUseStyles({
  root: {
    backgroundColor: 'white',
    gridColumn: '1 / 8',
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 32px)',
  },
  weekday: {
    color: GrayscalePalette[500],
    flexBasis: `${100 / 7}%`,
    fontSize: '12px',
    fontWeight: 700,
    padding: '11px 0',
    textAlign: 'center',
    lineHeight: '14px',
  },
});

const Header: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {DAY_OF_WEEK_ORDERING.map((d) => (
        <div key={d} className={classes.weekday}>
          {DAY_OF_WEEK_TO_INFO_MAPPING[d].abbreviation}
        </div>
      ))}
    </div>
  );
};

export { Header };
